import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { motion, AnimatePresence } from 'framer-motion'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import {
    FullViewContainer,
    FullViewSection,
    FullViewContent,
    CompactTitle,
    CompactSubtitle,
    CompactContentGrid,
    TextColumn,
    MediaColumn,
    CompactTextContainer,
    CompactText,
    ServiceListTitle,
    ServiceList,
    CarouselContainer,
    CarouselSlide,
    CarouselImage,
    CarouselVideo,
    CarouselControls,
    CarouselButton,
    CarouselArrow,
    ServiceCtaButton,
    containerVariants,
    itemVariants,
    fadeInVariants
} from '../styles/PageStyles'
import { buildWhatsappUrl } from '../data/contact'
import video from '../assets/iFrameRadix.mp4'
import pivotImg from '../assets/features/pivot-central.jpg'

export default function MultiplicacionSemillas() {
  const { t } = useTranslation()
  const [currentSlide, setCurrentSlide] = useState(0)
  const steps = t("multiSteps", { returnObjects: true })
  const stepList = Array.isArray(steps) ? steps : []

  const slides = [
    { type: 'video', src: video, alt: 'Video de multiplicación de semillas Radixagro' },
    { type: 'image', src: pivotImg, alt: 'Pivote central de riego propio de Radixagro' },
  ]

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length)
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
  const goToSlide = (index) => setCurrentSlide(index)

  return (
    <FullViewContainer>
      <FullViewSection>
        <FullViewContent>
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <CompactTitle variants={itemVariants}>
              {t("multiTitle")}
            </CompactTitle>

            <CompactSubtitle variants={itemVariants}>
              Servicios especializados de multiplicación de semillas
            </CompactSubtitle>

            <CompactContentGrid variants={itemVariants}>
              <TextColumn>
                <CompactTextContainer>
                  <CompactText>{t("multiIntro")}</CompactText>
                  <ServiceListTitle>{t("multiHowTitle")}</ServiceListTitle>
                  <ServiceList>
                    {stepList.map((step) => (
                      <li key={step.title}>
                        <strong>{step.title}</strong> {step.text}
                      </li>
                    ))}
                  </ServiceList>
                </CompactTextContainer>

              </TextColumn>

              <MediaColumn>
                <CarouselContainer variants={fadeInVariants}>
                  <AnimatePresence mode="wait">
                    <CarouselSlide
                      key={currentSlide}
                      initial={{ opacity: 0, x: 300 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -300 }}
                      transition={{ duration: 0.5 }}
                    >
                      {slides[currentSlide].type === 'image' ? (
                        <CarouselImage
                          src={slides[currentSlide].src}
                          alt={slides[currentSlide].alt}
                        />
                      ) : (
                        <CarouselVideo controls muted autoPlay loop playsInline>
                          <source src={slides[currentSlide].src} type="video/mp4" />
                          Tu navegador no soporta el elemento de video.
                        </CarouselVideo>
                      )}
                    </CarouselSlide>
                  </AnimatePresence>

                  <CarouselArrow
                    className="prev"
                    onClick={prevSlide}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <FaChevronLeft />
                  </CarouselArrow>

                  <CarouselArrow
                    className="next"
                    onClick={nextSlide}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <FaChevronRight />
                  </CarouselArrow>

                  <CarouselControls>
                    {slides.map((_, index) => (
                      <CarouselButton
                        key={index}
                        active={currentSlide === index}
                        onClick={() => goToSlide(index)}
                        whileHover={{ scale: 1.2 }}
                        whileTap={{ scale: 0.9 }}
                      />
                    ))}
                  </CarouselControls>
                </CarouselContainer>

                <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                  <ServiceCtaButton
                    href={buildWhatsappUrl('Hola, quiero multiplicar mi semilla con Radixagro.')}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Quiero multiplicar mi semilla con Radixagro
                  </ServiceCtaButton>
                </div>
              </MediaColumn>
            </CompactContentGrid>
          </motion.div>
        </FullViewContent>
      </FullViewSection>
    </FullViewContainer>
  )
}
